// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .pagination {
  width: 100%;
  text-align: center;
}
:host .pagination ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
:host .pagination ul .active {
  border-color: var(--my-custom-active);
}
:host .pagination ul li {
  display: inline-block;
  width: 30px;
  height: 30px;
  border-radius: 4px;
  border: 1px solid #777;
  margin: 4px;
  line-height: 28px;
  color: var(--my-custom-color2);
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/custom-pagination/custom-pagination.component.scss"],"names":[],"mappings":"AACE;EACE,WAAA;EACA,kBAAA;AAAJ;AAEI;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AAAN;AAEM;EACE,qCAAA;AAAR;AAGM;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,8BAAA;EACA,eAAA;AADR","sourcesContent":[":host{\n  .pagination {\n    width: 100%;\n    text-align: center;\n\n    ul {\n      list-style: none;\n      margin: 0;\n      padding: 0;\n\n      .active {\n        border-color: var(--my-custom-active);\n      }\n\n      li {\n        display: inline-block;\n        width: 30px;\n        height: 30px;\n        border-radius: 4px;\n        border: 1px solid #777;\n        margin: 4px;\n        line-height: 28px;\n        color: var(--my-custom-color2);\n        font-size: 12px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
